import { render, staticRenderFns } from "./MailClient.vue?vue&type=template&id=6cf01c4c&scoped=true"
import script from "./MailClient.vue?vue&type=script&lang=js"
export * from "./MailClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf01c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardSubtitle})
